import React from "react";
import { Grid } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useController } from "react-hook-form";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

function Algemeen() {
  const {
    field: { value: diagnosticsValue, onChange: diagnosticsOnChange },
  } = useController({ name: "diagnostics" });
  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <FormAsyncTC
            async={{
              url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=50",
              searchField: "systeemNaam",
            }}
            name={"vestiging_id"}
            rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
            tDefault={"Vestiging"}
            tKey={"gateways.form.algemeen.label.vestiging"}
          />

          <FormSwitchTC name={"inuse"} tDefault={"In gebruik"} tKey={"gateways.form.algemeen.label.inuse"} />
          <FormTextTC
            name={"naam"}
            rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
            tDefault={"Name"}
            tKey={"gateways.form.algemeen.label.naam"}
          />
          <FormControlledInputTC
            name={"gwport"}
            rules={{
              max: { value: 65535, message: getTranslation("The maximum value is 65535!") },
              min: { value: 1, message: getTranslation("The minimum value is 1!") },
              required: { value: true, message: getTranslation("This field is required!") },
            }}
            tKey={"Gateway port"}
            type={"number"}
          />
          <FormControlledInputTC
            name={"manageport"}
            rules={{
              max: { value: 65535, message: getTranslation("The maximum value is 65535!") },
              min: { value: 1, message: getTranslation("The minimum value is 1!") },
              required: { value: true, message: getTranslation("This field is required!") },
            }}
            tKey={"Manage port"}
            type={"number"}
          />
          <FormControlledInputTC name={"localServiceIp"} tKey={"Local service ip"} />
          <FormControlledInputTC
            name={"localServicePort"}
            rules={{
              max: { value: 65535, message: getTranslation("The maximum value is 65535!") },
              min: { value: 1, message: getTranslation("The minimum value is 1!") },
            }}
            tKey={"Local service port"}
            type={"number"}
          />
          <h3>
            <TranslationWrapper
              tDefault={"Diagnostic data"}
              tKey={"vestigingen.form.gateways.headers.stylingVestigingIdInUse"}
            />
          </h3>
          <FormTextTC
            disabled={true}
            name={"macAddress"}
            tDefault={"MAC Address"}
            tKey={"gateways.form.algemeen.label.macAddress"}
          />
          <FormTextTC
            disabled={true}
            name={"localIp"}
            tDefault={"Local IP"}
            tKey={"gateways.form.algemeen.label.localIp"}
          />
          <FormTextTC
            disabled={true}
            name={"localSubnet"}
            tDefault={"Local subnet"}
            tKey={"gateways.form.algemeen.label.localSubnet"}
          />
          <FormTextTC
            disabled={true}
            name={"localGateway"}
            tDefault={"Local gateway"}
            tKey={"gateways.form.algemeen.label.localGateway"}
          />
          <div dangerouslySetInnerHTML={{ __html: diagnosticsValue }} />
        </Grid>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
